/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingOfficeFlagIcon32Regular = forwardRef('BuildingOfficeFlagIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12 19a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M17 20a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z" }),
        React.createElement("path", { d: "M20 19a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M13 13a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z" }),
        React.createElement("path", { d: "M16 12a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M21 13a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 4v3h5a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H11a5 5 0 0 1-5-5V12a5 5 0 0 1 5-5h3V1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4Zm-5 5h10a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V12a3 3 0 0 1 3-3Z" })));
});
